export const getStyles = (token) => ({
  closeIcon: { color: "#1B1B1B" },
  card: { borderColor: "var(--color-lines)" },
  resourcePhotosCard: {
    marginTop: token.marginLG,
    marginBottom: token.marginXXL,
    borderColor: "var(--color-lines)"
  },
  resourceInfoCard: {
    marginBottom: token.marginXXL,
    borderColor: "var(--color-lines)"
  },
  title: { marginBottom: token.marginLG },
  mediaUpload: { marginBottom: token.marginSM },
  mediaGrid: { marginTop: token.marginXL },
  buttonsContainer: {
    display: "flex",
    gap: "12px",
    justifyContent: "flex-start"
  },
  cancelButton: {
    borderRadius: "100px",
    border: "1px solid var(--color-sportsman-brand)",
    height: "48px",
    padding: "12px 24px",
    fontWeight: 500
  },
  submitButton: {
    borderRadius: "100px",
    height: "48px",
    padding: "12px 24px",
    fontWeight: 500
  },
  characteristicTag: {
    display: "inline-flex",
    alignItems: "center",
    padding: "6px 12px",
    backgroundColor: "var(--color-blue-surface)",
    borderRadius: "100px",
    border: "1px solid var(--color-sportsman-brand)",
    margin: "5px",
    marginLeft: "0px",
    color: "var(--color-sportsman-brand)",
    fontSize: "14px",
    lineHeight: "20px"
  },
  closeTagButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "8px",
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    border: "1px solid var(--color-sportsman-brand)",
    cursor: "pointer"
  },
  closeTagIcon: {
    fontSize: "8px",
    color: "var(--color-sportsman-brand)"
  },
  selectContainer: { width: "100%" },
  selectDropdown: { padding: "8px 0" },
  selectMenuItem: { backgroundColor: "var(--color-blue-surface)" }
})
